import styled from '@emotion/styled';
import { sectionStyles } from '../css/styles';
import theme from '../theme';
import { LangContext } from '../context/LangContext'; 
import { DeviceContext } from '../context/DeviceContext'; 
import { forwardRef, useContext, useRef } from 'react';
import { FadeInSection } from '../hooks/FadeInSection';
import { Link } from 'react-router-dom';

//export default function Section2({ scrollRef }) {
const Section2 = forwardRef((props, ref) => {

    const sectionRef = useRef(null);

    const { selectLanguage } = useContext(LangContext);
    const { isMobile, toolbarHeight } = useContext(DeviceContext);    
  
    const Section2 = styled.section`    
        ${sectionStyles}    
        height:1200px;    
        background-image: url('/images/bg/section2_bg_pc.png');
        background-size: cover;
        text-align:center;
        margin:auto;

        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap:34px;
        
        ${theme.breakpoints.xl_1920} {
            background-image: url('/images/bg/section2_bg_pc_1920.png');
            height:900px;
        }

        ${theme.breakpoints.xl} {                        
            height:100%;
            min-height: 100%;
            min-heght: -webkit-fill-available;

            background-image: url('/images/bg/content_bg_mobile_2.png');
            background-size: cover; 
            background-position: center center;
            background-repeat: no-repeat;
            gap:0px;
        }
    `;

    const Title1 = styled.div`
        font-size:1.875rem;
        color:white;
        opacity:.2;
        // margin-bottom: 30px;
        display:flex;
        align-items:center;
        justify-content:center;
        gap:6px;

        ${theme.breakpoints.xl_1920} {
            font-size:20px;
        }

        ${theme.breakpoints.xl} {
            margin-top:50px;
            font-size:14px;
        }
    `;

    const TitleNumber = styled.span`
        font-size:4.375rem;

        ${theme.breakpoints.xl_1920} {
            font-size:50px;
        }

        ${theme.breakpoints.xl} {
            font-size:24px;
            line-height:165%;            
        }
    `;

    const Title2 = styled.div`
        font-size:4.125rem;
        color:white;

        ${theme.breakpoints.xl_1920} {
            font-size:52px;
        }

        ${theme.breakpoints.xl} {
            font-size:26px;
        }
    `;

    const Text = styled.div`
        font-size: 1.75rem;
        font-family: "Gmarket Sans";
        line-height: 165%; 
        color:white;
        opacity: .8;
        white-space: pre-line;

        ${theme.breakpoints.xl_1920} {
            font-size:24px;
        }

        ${theme.breakpoints.xl} {
            font-size:14px;
            margin:14px 0 14px 0;
        }
    `;

    const TitleButton = styled.div`
        // display: flex;
        // width: 516px;
        // height: 96px;        
        // justify-content: center;
        // align-items: center;        

        // font-size: 2.5rem;
        // color:white;

        // border-radius: 6px;
        // border: 2px solid #FFF;
        // background: linear-gradient(180deg, #FB8937 0.43%, #D13B0C 100.43%);
        // box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.25);

        img{
            width: 480px;

            transition:all 0.2s ease;

            &:active{                
                display:inline-block;
                scale: 1.1;
            }
        }

        ${theme.breakpoints.xl_1920} {
            // width: 460px;
            // height: 80px;  
            // font-size:32px; 
        }

        ${theme.breakpoints.xl} {
            img{
                width: 260px;
            }

            margin:0 0 14px 0;
        }
    `;

    const Deadline = styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        gap:20px;

        div:first-of-type{
            border-radius: 12px;
            border:1px solid #FF6F1E;
            color:#FF6F1E;
            font-size:1.875rem;
            text-align: center;
            padding:8px 30px;
            line-height: 165%;
        }

        div:nth-of-type(2){
            color: #FF6F1E;        
            font-size: 2.375rem;
        }

        div:nth-of-type(3){
            color:white;
            opacity: .5;
            font-size: 2.25rem;
        }

        ${theme.breakpoints.xl_1920} {                

            div:first-of-type, div:nth-of-type(2), div:nth-of-type(3){
                font-size:32px;
            }
        }

        ${theme.breakpoints.xl} {
            flex-direction:column;
            gap:10px;
            
            div:first-of-type{
                font-size:14px;
                padding:4px 12px;
            }
    
            div:nth-of-type(2){
                font-size:15px;
            }
    
            div:nth-of-type(3){
                color:white;
                opacity: .5;
                font-size: 16px;
            }

            margin:0 0 14px 0;

        }

    `;

    const GoodsBox = styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        gap:24px;
        color:white;

        ${theme.breakpoints.xl} {
            gap:16px;
        }
    `;

    const Goods = styled.div`
        padding: 30px 40px;   
        border-radius: 6px 24px;
        border: 1px solid #FF6F1E;
        background: linear-gradient(180deg, rgba(164, 49, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%);
        backdrop-filter: blur(10px);

        // background: linear-gradient(180deg, rgba(164, 49, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%);
        // backdrop-filter: blur(10px);
        
        // background-color: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        // backdrop-filter: blur(10px);        
        gap:40px;  

        img{
            height:200px;
        }

        img:first-of-type{
            display:none;
        }

        ${theme.breakpoints.xl_1920} {
            gap:20px; 
            img{
                height:140px;
            }
        }

        ${theme.breakpoints.xl} {
            padding: 16px 8px;
            flex-direction:column;
            border-radius: 6px;
            gap:8px;
            position:relative;     

            img{
                height:104px;
            }

            img:first-of-type{
                display:block;
            }
        }


    `;

    const GoodsBoxTitle = styled.div`
        color: #FF6F1E;
        text-align: start;
        font-size: 2.5rem;

        ${theme.breakpoints.xl_1920} {     
            font-size:24px;
        }

        ${theme.breakpoints.xl} {            
            text-align:center;
            font-size: 12px;
            margin-bottom:2px;
        }
    `;
    const GoodsBoxText1 = styled.div`        
        font-size: 2.5rem;
        line-height: 165%;
        text-align: start; 

        ${theme.breakpoints.xl_1920} {     
            font-size:32px;
        }

        ${theme.breakpoints.xl} {            
            text-align:center;
            font-size: 16px;
            margin-bottom:8px;
        }
    `;
    const GoodsBoxHr = styled.div`
        width:100%;
        height:2px;
        background: #FF6F1E;
        border:none;        
    `;
    const GoodsBoxText2 = styled.div`            
        width:160px;
        height:66px;
        margin-left:-5px;

        background-image: url('/images/icon/button_bg.png');
        background-size: cover; 
        background-position: center center;
        background-repeat: no-repeat;
        
        display: flex;
        // padding: 0px 39px;
        justify-content: center;
        align-items: center;        
        line-height: 165%;
        font-size:32px;
        // font-size:2.5rem;
        border-radius: 12px;
        //background: var(--Red-400, #F90052);

        ${theme.breakpoints.xl_1920} {     
            font-size:32px;
        }

        ${theme.breakpoints.xl} {  
            width:100px;
            height:40px;          
            font-size:18px;
            margin:auto;
        }
    `;

  return (
    <Section2 ref={ref} toolbarHeight={toolbarHeight}>
        <Title1>
            <TitleNumber>01</TitleNumber> <div>{selectLanguage === '한국어' ? '사전예약 보상' : 'REWARD'}</div>
        </Title1>

        <FadeInSection>
        <Title2>
            {
                selectLanguage === '한국어' ? 
                    isMobile === true ? '사전예약 참여하고 보상받기' : '사전예약 참여하기' : <>PRE-REGISTRATION<br/>NOW LIVE!</>
            }
        </Title2>
        </FadeInSection>

        <FadeInSection>
        <Text>
            {
              isMobile ?               
                selectLanguage === '한국어' ? 
                  `정식 런칭 기념 간단한 퀘스트에 참여하세요!
                  퀘스트에 참여만 해도 풍성한 보상을
                  확정적으로 드립니다.`
                  : `Join our official launch celebration
                  Quest & Claim abundant rewards.`
              :
                selectLanguage === '한국어' ? 
                  `정식 런칭 기념 간단한 퀘스트에 참여하세요!
                  퀘스트에 참여만 해도 풍성한 보상을 확정적으로 드립니다.` 
                  : `Join the Celebration Quest for Official Launch!
                  Just participating in the quest guarantees abundant rewards for you.`
            }
        </Text>
        </FadeInSection>

        <FadeInSection>            
            <TitleButton>
                <Link to="https://play.carv.io/events/4dd51c33-5ab5-5586-ad5c-1e85c0d62380/detail" target='_blank'>
                    <img src={`/images/icon/pre_regi_button_${selectLanguage === '한국어' ? 'kor' : 'eng' }.png`} alt=""/>
                </Link>
            </TitleButton>
        </FadeInSection>
        
        <FadeInSection>
        <Deadline>
            {selectLanguage === '한국어' 
              ? <>
                <div>사전예약 기간</div>
                <div>2024.05.23</div>
                <div>~ 정식 런칭 전까지</div>
              </>
              : <>
              <div>Event Period</div>
              <div>May 23, 2024 ~ Until Launch</div>              
              {/* <div>~ Until Official Launch</div> */}
            </>
            }            
        </Deadline>
        </FadeInSection>
        
        <FadeInSection>
        <GoodsBox>
            {/* 
                style={isMobile ? {height:'104px'} : {height:'200px'}}
            */}
            <>
                <Goods>
                    <img src="/images/genie_1.png" alt="" style={{width:'68px',height:'76px',position:'absolute',top:'-50px',left:'-30px'}}/>  
                    <img src="/images/goods1.png" alt=""/>
                    <div>
                        <GoodsBoxTitle> {selectLanguage === '한국어' ? '커먼 등급' : 'EQUIPMENT'}</GoodsBoxTitle>
                        <GoodsBoxText1> {selectLanguage === '한국어' ? '젬 블록(장비)' : 'GEM BLOCK'}</GoodsBoxText1>
                        <GoodsBoxText2> {selectLanguage === '한국어' ? '200개' : 'x200'}</GoodsBoxText2>
                    </div>   
                </Goods>
                <Goods>
                    <img src="/images/genie_2.png" alt="" style={{width:'63px',height:'61px',position:'absolute',top:'-40px',left:'100px'}}/>
                    <img src="/images/goods2.png" alt=""/>
                    <div>
                        <GoodsBoxTitle> {selectLanguage === '한국어' ? '유니크 등급' : isMobile ? 'UNIQUE DRAGON' : 'UNIQUE'}</GoodsBoxTitle>
                        <GoodsBoxText1>
                            {selectLanguage === '한국어' 
                                ? '캐릭터 뽑기권' 
                                : isMobile ? 'TICKET' : 'DRAGON TICKET'}
                        </GoodsBoxText1>
                        <GoodsBoxText2> {selectLanguage === '한국어' ? '3개' : 'x3'}</GoodsBoxText2>
                    </div>
                </Goods>
            </>
        </GoodsBox>
        </FadeInSection>

    </Section2>
  )
});

export default Section2;